import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=416f03a5&scoped=true&"
import script from "@/views/Users/Teacher/Roster.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Teacher/Roster.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Teacher/roster.scss?vue&type=style&index=0&id=416f03a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f03a5",
  null
  
)

export default component.exports